import { z } from 'zod/v4';

export const themeNames = ['default', 'publicis'] as const;

export const allowedOriginsConfigSchema = z.record(
  z.string(), // origin
  z.object({
    allowSubdomains: z.boolean(),
    protocol: z.enum(['http', 'https']),
    themeName: z.enum(themeNames),
  })
);

export const allowedOriginsConfigJsonSchema = z
  .string()
  .transform((str, ctx) => {
    try {
      const parsed: unknown = JSON.parse(str);
      return allowedOriginsConfigSchema.parse(parsed);
      // eslint-disable-next-line sonarjs/no-ignored-exceptions -- parse errors are reported via ctx.addIssue; re-throwing would bypass Zod's error handling
    } catch (_e) {
      ctx.addIssue({
        code: 'custom',
        message: 'Invalid JSON format for allowed origins config',
        fatal: true,
      });
      return z.NEVER;
    }
  });

export type AllowedOriginsConfig = z.infer<typeof allowedOriginsConfigSchema>;

export type ThemeName = z.infer<
  typeof allowedOriginsConfigSchema
>[string]['themeName'];
